import {useQuery} from '@tanstack/react-query';
import {getCatalogUniqueProductValues} from '../../../utils/ProductAPI';
import {updateCatalogUniqueValues} from '../../../redux/actions/ProductMetaDataActions';
import {useDispatch} from 'react-redux';

export const useGetCatalogUniqueProductValuesQuery = (orgCatalogId, productFields) => {
    const dispatch = useDispatch();
    return useQuery({
        enabled: !!orgCatalogId && !!productFields,
        queryKey: ['get-catalog-unique-product-values', orgCatalogId, productFields],
        queryFn: (context) => getCatalogUniqueProductValues(orgCatalogId, productFields),
        onSuccess: (data) => {
            dispatch(updateCatalogUniqueValues(data));
        },
    });
};
